import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, AgentFieldValidationDto, AgentProvisionFormDataDto, DocumentDto, MsisdnDto, PartnerDto, PartnerFieldValidationDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpPartnerService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/partner', authService);
	}

	public getAll(): Observable<ResultListDto<PartnerDto>> {
		return super.doGet(true, `/`);
	}
	public get(id: number): Observable<PartnerDto>{
		return super.doGet(true, `/${id}`);
	}
	public create(input: PartnerDto): Observable<PartnerDto>{
		return super.doPost(true, `/`, input);
	}
	public edit(id: number, input: PartnerDto): Observable<PartnerDto>{
		return super.doPost(true, `/${id}`, input);
	}
	public validate(field: string, value: string, partner?: PartnerDto):Observable<PartnerFieldValidationDto>{
		if(partner){
			return super.doPost(true, `/${partner.id}/validate/${field}`, value);
		}else{
			return super.doPost(true, `/validate/${field}`, value);
		}
	}
}
